"use client";
import { motion } from "framer-motion";

const SpinningBadge = () => {
  return (
    <div className="relative w-36 h-36 flex items-center justify-center bg-primary rounded-full">
      <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 15, repeat: Infinity, ease: "linear" }}
        className="w-full h-full"
      >
        <svg viewBox="0 0 100 100" className="w-full h-full">
          <path
            id="circlePath"
            d="M 50, 50 m -38, 0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0"
            fill="none"
          />
          <text className="text-[9px] uppercase font-black tracking-widest fill-[#212129]">
            <textPath xlinkHref="#circlePath">
              BRANDING • STRATEGY • CREATIVE • DIGITAL •
            </textPath>
          </text>
        </svg>
      </motion.div>
    </div>
  );
};

export default SpinningBadge;
